import { useId, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Icons } from "@/components/ui/icons";
import { DisclosurePanel } from "@/components/ui/disclosure-panel";
import { useT } from "@/i18n";
import { settingsBrowserMessages } from "@/i18n/messages/settings-browser";
import { isMacPlatform } from "@/lib/os-platform";

/** What helps the Denker extension connect, on macOS and Windows alike;
 * on macOS also Safari's and Apple Events' own steps. */
export function BrowserConnectionTroubleshooting() {
  const t = useT(settingsBrowserMessages);
  const mac = isMacPlatform();
  const [open, setOpen] = useState(false);
  const panelId = useId();
  const toggleRef = useRef<HTMLButtonElement>(null);
  return (
    <div
      className="mt-3 px-2 text-appkit-small text-muted"
      data-testid="browser-connection-troubleshooting"
    >
      <Button
        ref={toggleRef}
        type="button"
        variant="ghost"
        className="h-auto justify-start gap-1 px-0 py-2 text-appkit-small font-normal text-muted"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={() => setOpen((value) => !value)}
        data-testid="browser-connection-troubleshooting-toggle"
      >
        <Icons.ChevronDown
          className="denker-disclosure-chevron h-3 w-3"
          data-open={open}
          aria-hidden="true"
        />
        {t("troubleshooting")}
      </Button>
      <DisclosurePanel id={panelId} open={open} returnFocusRef={toggleRef}>
        <p className="py-2">
          {t(
            mac
              ? "troubleshootingExtensionMac"
              : "troubleshootingExtensionWindows",
          )}
        </p>
        <p className="py-2">{t("troubleshootingTurnedOff")}</p>
        <p className="py-2">{t("troubleshootingAfterUpdate")}</p>
        {mac ? (
          <>
            <p className="py-2">{t("troubleshootingAppleEvents")}</p>
            <p className="py-2">{t("troubleshootingPermissions")}</p>
            <p className="py-2">{t("troubleshootingScripting")}</p>
          </>
        ) : null}
      </DisclosurePanel>
    </div>
  );
}
